import React from 'react';
import { useMutation } from '@apollo/client';
import TrackerEditManualActivityMutation from './TrackerEditManualActivityMutation';
import TrackerQuery from '../Fetch/TrackerQuery';
import { formatIsoDate } from '../../../Helpers/dateFormatter';

interface ITrackerEditManualActivityConnectorApolloProps {
  children: ({
    editManualActivity,
  }: {
    editManualActivity: (input: any) => Promise<any>;
  }) => React.ReactElement;
  post: any;
}

const TrackerEditManualActivityConnectorApollo: React.FC<
  ITrackerEditManualActivityConnectorApolloProps
> = ({ children, post }) => {
  const [editManualActivityMutation] = useMutation(TrackerEditManualActivityMutation);

  const editManualActivity = async (input: any) => {
    const date = input.dateTime
      ? formatIsoDate(new Date(input.dateTime))
      : formatIsoDate(new Date());

    const response = await editManualActivityMutation({
      variables: { input },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: TrackerQuery,
          variables: {
            date,
          },
        },
      ],
    });

    if (post) {
      post('reload');
    }

    return response.data.dailyTracker.editManualActivity;
  };

  return children({ editManualActivity });
};

export default TrackerEditManualActivityConnectorApollo;
